// extracted by mini-css-extract-plugin
export var actions = "_dy-g";
export var benefitCard = "_dy-b";
export var benefitIcon = "_dy-d";
export var benefitLabel = "_dy-f";
export var benefits = "_dy-a";
export var benefitsSection = "_dy-8";
export var bodyText = "_dy-7";
export var closeButton = "_dy-2";
export var content = "_dy-3";
export var eyebrow = "_dy-4";
export var heading = "_dy-5";
export var image = "_dy-i";
export var imagePanel = "_dy-h";
export var modal = "_dy-0";
export var offerCard = "_dy-c";
export var offerIcon = "_dy-e";
export var sectionLabel = "_dy-9";
export var shell = "_dy-1";
export var title = "_dy-6";